import React from 'react';
import { Image } from 'react-bootstrap';
import { AssignImg } from '../../../../assets/images';

const Nurse = () => {
    return (
        <div className="nurse_list_screen">
            <div className="nurse_details active">
                <div className="left_area">
                    <div className="img_one">
                        <Image src={AssignImg} alt="..." />
                    </div>
                </div>
                <div className="right_area">
                    <h3>Robert William</h3>
                    <div className="tag">
                        <p>Nurse</p>
                    </div>
                </div>
            </div>
            <div className="nurse_details">
                <div className="left_area">
                    <div className="img_one">
                        <Image src={AssignImg} alt="..." />
                    </div>
                </div>
                <div className="right_area">
                    <h3>Robert William</h3>
                    <div className="tag">
                        <p>Nurse</p>
                    </div>
                </div>
            </div>
            <div className="nurse_details">
                <div className="left_area">
                    <div className="img_one">
                        <Image src={AssignImg} alt="..." />
                    </div>
                </div>
                <div className="right_area">
                    <h3>Robert William</h3>
                    <div className="tag">
                        <p>Nurse</p>
                    </div>
                </div>
            </div>
            <div className="nurse_details">
                <div className="left_area">
                    <div className="img_one">
                        <Image src={AssignImg} alt="..." />
                    </div>
                </div>
                <div className="right_area">
                    <h3>Robert William</h3>
                    <div className="tag">
                        <p>Nurse</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Nurse;